exports = module.exports = require("../../../_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-index-bar__sidebar {\n  position: fixed;\n  top: 50%;\n  right: 0;\n  z-index: 2;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n  text-align: center;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.van-index-bar__index {\n  padding: 0 0.213333rem 0 0.426667rem;\n  font-weight: 500;\n  font-size: 0.266667rem;\n  line-height: 0.373333rem;\n}\n\n.van-index-bar__index--active {\n  color: #ee0a24;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_px2rem-loader@0.1.9@px2rem-loader?{"remUnit":37.5}!./~/_vant@2.13.2@vant/lib/index-bar/index.css
// module id = 226
// module chunks = 320 321